import { Link } from '@tanstack/react-router';
import { formatAuditValue, subjectRoute } from './audit-utils.js';

/**
 * Subject of an audit entry: type label + name, linked to its admin page when one exists.
 * @param {{ subject: any, showType?: boolean }} props
 */
export function AuditSubject({ subject, showType = true }) {
  if (!subject) return <span className="text-muted-foreground">–</span>;
  const route = subjectRoute(subject);
  const name = subject.label ?? `#${subject.id}`;
  return (
    <span className="flex min-w-0 flex-col">
      {showType && <span className="text-xs text-muted-foreground">{subject.type_label}</span>}
      {route ? (
        <Link {...route} className="truncate font-medium text-primary hover:underline">
          {name}
        </Link>
      ) : (
        <span className="truncate">
          {name}
          {!subject.exists && <span className="ml-1 text-xs text-muted-foreground">(nicht mehr vorhanden)</span>}
        </span>
      )}
    </span>
  );
}

/**
 * Old/new table of an audit entry (`changes` from the API; sensitive values arrive as „[entfernt]“).
 * @param {{ changes: Array<{ attribute: string, label: string, old: unknown, new: unknown }> }} props
 */
export function AuditDiff({ changes }) {
  if (!changes?.length) return <p className="text-sm text-muted-foreground">Keine Feldänderungen protokolliert.</p>;
  return (
    <div className="overflow-x-auto rounded-md border">
      <table className="w-full text-sm" aria-label="Geänderte Felder">
        <thead className="bg-muted/50 text-left text-xs text-muted-foreground">
          <tr>
            <th scope="col" className="px-3 py-2 font-medium">
              Feld
            </th>
            <th scope="col" className="px-3 py-2 font-medium">
              Vorher
            </th>
            <th scope="col" className="px-3 py-2 font-medium">
              Nachher
            </th>
          </tr>
        </thead>
        <tbody>
          {changes.map((change) => (
            <tr key={change.attribute} className="border-t align-top">
              <th scope="row" className="px-3 py-2 text-left font-medium">
                {change.label}
              </th>
              <td className="px-3 py-2 break-words text-muted-foreground">
                <del className="decoration-destructive/50">{formatAuditValue(change.old)}</del>
              </td>
              <td className="px-3 py-2 break-words">
                <ins className="no-underline">{formatAuditValue(change.new)}</ins>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
